import { ActivityBuilderDrawerLoading } from 'approot/activity-builder/activity-builder-drawer';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { useGetStimulusResource } from 'approot/shared/stimulus/stimulus.hooks';
import type { GetStimulusResourceQuery } from '../../../shared/stimulus/stimulus.graphql.generated';
import DocumentEditStimulusPreview from './document-edit-stimulus-preview';
import { EditProps } from './document.constants';
import type { Pluck } from 'lib/gql/pluck';

const DocumentEditDrawer = ({
  id,
  properties,
  type,
  title,
  lessonId,
  sectionId,
}: EditProps & {
  title?: string;
}) => {
  const { closeDrawer } = useActivityBuilderContext();

  const { data, loading } = useGetStimulusResource(
    properties.stimulusId!,
    true
  );

  const stimulus = data?.getStimulusResource as Extract<
    Pluck<GetStimulusResourceQuery, 'getStimulusResource'>,
    { __typename: 'StimulusResourceDocument' }
  >;

  return loading ? (
    <ActivityBuilderDrawerLoading title={title || type} onClose={closeDrawer} />
  ) : (
    <DocumentEditStimulusPreview
      componentId={id}
      stimulus={stimulus}
      title={title}
      contentId={lessonId}
      sectionId={sectionId}
    />
  );
};

export default DocumentEditDrawer;
